import { createReducer } from 'reduxsauce';
import {
  INITIAL_STATE,
  request,
  success,
  failure,
  clear
} from '../../ChangeProgramCampusModality/activateUseCase/reducer';
import { Types } from './actions';

export default createReducer(INITIAL_STATE, {
  [Types.ACTIVATE_CARNET_UNIVERSITY_REQUEST]: request,
  [Types.ACTIVATE_CARNET_UNIVERSITY_SUCCESS]: success,
  [Types.ACTIVATE_CARNET_UNIVERSITY_FAILURE]: failure,
  [Types.ACTIVATE_CARNET_UNIVERSITY_CLEAR]: clear
});
